import auth from '@/auth/index'
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    meta: {
      title: '智能合约检测',
      breadLevel: 0,
      icon: 'icon-contractdetector',
      auth: auth.contractdetector
    },
    children: [
      {
        path: '/rust-contract-detector',
        name: 'rustContractDetector',
        component: resolve => require(['@/views/contractdetector/rustContractDetector'], resolve),
        meta: {
          title: 'Rust合约检测',
          breadLevel: 0,
          auth: auth.contractdetector.rust
        }
      },
      {
        path: '/rust-contract-detector/rust-contract-detail',
        name: 'rustContractDetail',
        component: resolve => require(['@/views/contractdetector/rustContractDetail'], resolve),
        meta: {
          title: 'Rust合约详情',
          breadLevel: 1
        }
      },
      {
        path: '/rust-contract-detector/rust-task-detail',
        name: 'rustTaskDetail',
        component: resolve => require(['@/views/contractdetector/rustTaskDetail'], resolve),
        meta: {
          title: 'Rust任务详情',
          breadLevel: 1
        }
      },
      {
        path: '/solidity-contract-detector',
        name: 'solidityContractDetector',
        component: resolve =>
          require(['@/views/contractdetector/solidityContractDetector'], resolve),
        meta: {
          title: 'Solidity合约检测',
          breadLevel: 0,
          auth: auth.contractdetector.solidity
        }
      },
      {
        path: '/solidity-contract-detector/solidity-contract-detail',
        name: 'solidityContractDetail',
        component: resolve => require(['@/views/contractdetector/solidityContractDetail'], resolve),
        meta: {
          title: 'Solidity合约详情',
          breadLevel: 1
        }
      },
      {
        path: '/solidity-contract-detector/solidity-task-detail',
        name: 'solidityTaskDetail',
        component: resolve => require(['@/views/contractdetector/solidityTaskDetail'], resolve),
        meta: {
          title: 'Solidity任务详情',
          breadLevel: 1
        }
      }
    ]
  }
]

export default routes
